import script from "./DishAssignmentView.vue?vue&type=script&setup=true&lang=js"
export * from "./DishAssignmentView.vue?vue&type=script&setup=true&lang=js"

import "./DishAssignmentView.vue?vue&type=style&index=0&id=42f838c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.18_vue@3.5.18_typescript@5.8.3__webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42f838c8"]])

export default __exports__